import { useState, useEffect } from "react";
import {
  selectCollectionFavorites,
  selectUser,
  setCollectionFavorites,
  setCurrentCollectionId,
  setEditingCollection,
  setSelectedSubMenu,
  SyncProgress,
} from "../../redux/features/appData";
import {
  Collection,
  CollectionAccessTypes,
  CollectionFavorite,
} from "winslow-core";
import "./CollectionCard.css";

import { iconPath } from "winslow-core";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  apiFavoriteCollectionForUser,
  apiUnfavoriteCollectionForUser,
} from "../../services/CollectionService";
import { MENUS } from "../config/menus";
import { CollectionQuestionCount } from "../../services/CollectionService.types";

type CollectionsCardProps = {
  collection: Collection;
  questionCounts: CollectionQuestionCount[] | null;
};

export const CollectionCard = ({
  collection,
  questionCounts,
}: CollectionsCardProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const storeUser = useSelector(selectUser);
  const collectionFavorites = useSelector(selectCollectionFavorites);

  const [questionCount, setQuestionCount] = useState<number>(0);

  useEffect(() => {
    if (questionCounts) {
      const index = questionCounts.findIndex((qc: CollectionQuestionCount) => {
        return qc.collectionId === collection.id;
      });

      if (index !== -1) {
        setQuestionCount(questionCounts[index].count);
      }
    }
  });

  const isFavorited = () => {
    if (!collectionFavorites) {
      return false;
    }

    const index = collectionFavorites.findIndex((cf: CollectionFavorite) => {
      return cf.collectionId === collection.id;
    });

    return index !== -1;
  };

  const handleFavoriteCollection = async () => {
    if (!storeUser || !storeUser.currentWorkspaceId) {
      return;
    }

    if (!collectionFavorites) {
      await apiFavoriteCollectionForUser({
        workspaceId: storeUser.currentWorkspaceId,
        collectionId: collection.id,
        userId: storeUser.id,
      });
    } else {
      const index = collectionFavorites.findIndex((cf: CollectionFavorite) => {
        return cf.collectionId === collection.id;
      });

      if (index === -1) {
        await apiFavoriteCollectionForUser({
          workspaceId: storeUser.currentWorkspaceId,
          collectionId: collection.id,
          userId: storeUser.id,
        });
      } else {
        await apiUnfavoriteCollectionForUser({
          workspaceId: storeUser.currentWorkspaceId,
          collectionId: collection.id,
          userId: storeUser.id,
        });
      }
    }
  };

  const handleEditCollection = (collectionId: string) => {
    dispatch(setEditingCollection(collection));
    navigate("/waz/kb/create");
  };

  return (
    <div
      className="collection-card"
      onClick={() => {
        dispatch(setSelectedSubMenu(MENUS.COLLECTION_ASK));
        dispatch(setCurrentCollectionId(collection.id));
        navigate("/waz/collection/" + collection.id);
      }}>
      <div className="collection-card-header">
        <div
          className="collection-card-icon"
          style={{ backgroundColor: collection.color }}>
          &nbsp;
          {collection.accessType === CollectionAccessTypes.PRIVATE && (
            <div className="collection-card-security">
              <img src={iconPath("lock.svg", storeUser)} alt="" />
            </div>
          )}
        </div>
        <div className="collection-card-status">
          {collection.syncStatus === SyncProgress.ERRORED && (
            <div
              className="collection-card-status-label"
              style={{ backgroundColor: "var(--status-error)" }}>
              Errored
            </div>
          )}
          {collection.syncStatus === SyncProgress.PROCESSING && (
            <div
              className="collection-card-status-label"
              style={{ backgroundColor: "var(--status-processing)" }}>
              Processing
            </div>
          )}
        </div>
        <div
          className="collection-card-icons"
          onClick={(e: any) => {
            e.stopPropagation();
            // handleFavoriteCollection();
            handleEditCollection(collection.id);
          }}>
          {/* <img
            src={iconPath(
              isFavorited()
                ? SHARES_IMAGES.FAVORITE_ON
                : SHARES_IMAGES.FAVORITE_OFF,
              storeUser
            )}
            alt=""
          /> */}
          <img src={iconPath("edit.svg", storeUser)} alt="" />
        </div>
      </div>

      <div className="collection-card-title">{collection.title}</div>

      <div className="collection-card-description">
        {collection.description}
      </div>

      <div className="collection-card-footer">
        <div className="collection-card-resources">
          {collection.linkRecords.length} resource
          {collection.linkRecords.length === 1 ? "" : "s"}
          &nbsp;-&nbsp;
          {questionCount} question{questionCount === 1 ? "" : "s"}
        </div>
        {/* <div className="collection-card-questions">
          {questionCount} Question{questionCount === 1 ? "" : "s"}
        </div> */}
      </div>
    </div>
  );
};
